var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cell span-12-xs",attrs:{"id":"report-wrapper"}},[_c('ActionBar',{attrs:{"actions":_vm.actions}}),_c('DataTable',{attrs:{"columns":_vm.columns,"records":_vm.records,"settings":_vm.settings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }